import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/img/icon/deleteFilledAntDesignRed.svg'


const _hoisted_1 = { class: "type-bus-form flex-col flex relative h-full px-3 overflow-x-hidden overflow-y-auto" }
const _hoisted_2 = { class: "title-form py-5 mb-6 flex items-center justify-between" }
const _hoisted_3 = { class: "font-bold" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-3 h-3",
  alt: "delete"
}, null, -1)
const _hoisted_5 = { class: "p-fluid" }
const _hoisted_6 = { class: "p-field mb-4" }
const _hoisted_7 = /*#__PURE__*/_createVNode("label", {
  for: "kota",
  class: "text-body2"
}, "Kota", -1)
const _hoisted_8 = {
  key: 0,
  class: "p-error"
}
const _hoisted_9 = { class: "p-field mb-4" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", {
  for: "targetId",
  class: "text-body2"
}, "Target", -1)
const _hoisted_11 = { class: "p-field mb-4" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", {
  for: "transportationType",
  class: "text-body2"
}, "Jenis Kendaraan", -1)
const _hoisted_13 = {
  key: 0,
  class: "p-error"
}
const _hoisted_14 = { class: "btn-action w-full mt-auto mb-5" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Kembali")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")
  const _component_InputNumber = _resolveComponent("InputNumber")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("h6", _hoisted_3, _toDisplayString(_ctx.title), 1),
      (_ctx.dataEdit && _ctx.route.meta.permission.delete)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: "background-red-lighten-5 p-3 rounded-md cursor-pointer",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deleteData()))
          }, [
            _hoisted_4
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("form", {
      id: "form-courier-comission",
      onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.submitData(!_ctx.v$.$invalid)), ["prevent"]))
    }, [
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_Multiselect, {
            id: "kota",
            class: "mt-1 input-primary",
            modelValue: _ctx.v$.kotaId.$model,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.kotaId.$model = $event)),
            placeholder: "Pilih Kota",
            options: _ctx.kotaOption,
            searchable: true
          }, null, 8, ["modelValue", "options"]),
          ((_ctx.v$.kotaId.$invalid && _ctx.submitted) || _ctx.v$.kotaId.$pending.$response)
            ? (_openBlock(), _createBlock("small", _hoisted_8, _toDisplayString(_ctx.v$.kotaId.required.$message), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(_component_InputNumber, {
            id: "targetId",
            class: "input-primary rounded-lg mt-1",
            modelValue: _ctx.dataForm.target,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.dataForm.target = $event)),
            showButtons: "",
            buttonLayout: "horizontal",
            incrementButtonIcon: "pi pi-plus",
            decrementButtonIcon: "pi pi-minus",
            min: 0,
            placeholder: "Kuota"
          }, null, 8, ["modelValue"])
        ]),
        _createVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode(_component_Multiselect, {
            id: "transportationType",
            class: "mt-1 input-primary",
            modelValue: _ctx.v$.transportationType.$model,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.transportationType.$model = $event)),
            placeholder: "Pilih Jenis Kendaraan",
            options: _ctx.transportationTypeOption,
            searchable: true,
            mode: "tags"
          }, null, 8, ["modelValue", "options"]),
          ((_ctx.v$.transportationType.$invalid && _ctx.submitted) || _ctx.v$.transportationType.$pending.$response)
            ? (_openBlock(), _createBlock("small", _hoisted_13, _toDisplayString(_ctx.v$.transportationType.required.$message), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ], 32),
    _createVNode("div", _hoisted_14, [
      _createVNode(_component_Button, {
        label: "Simpan",
        type: "submit",
        form: "form-courier-comission",
        class: "font-semibold p-button-sm btn-primary px-10 mr-2"
      }),
      _createVNode(_component_Button, {
        class: "btn-secondary text-black p-button-sm px-10 py-1",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.closeSidebar()))
      }, {
        default: _withCtx(() => [
          _hoisted_15
        ]),
        _: 1
      })
    ])
  ]))
}